import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { callPostApi } from "../../function/ApiCallFunction";
import { consoleColors, headingCase } from "../admin/consoleTheme";
import { IssuedCustomerTable, TicketSearchField, TicketWinnerTable, issuedStatsLine, matchesCustomer } from "../admin/AdminTickets";
import { cashiLogo } from "../../include/cashiBrand";

export default function TicketIssuedPublic() {
  const { token = "" } = useParams();
  const [params] = useSearchParams();
  const winnersOnly = params.get("view") === "winners";
  const [ticket, setTicket] = useState(null);
  const [orders, setOrders] = useState([]);
  const [winners, setWinners] = useState([]);
  const [missing, setMissing] = useState(false);
  const [query, setQuery] = useState("");
  const shown = orders.filter((order) => matchesCustomer(order, query));

  useEffect(() => {
    let mounted = true;
    callPostApi("draw-ticket", { mod: "TICKET_ISSUED_PUBLIC", data_arr: { token } }).then((result) => {
      if (!mounted) return;
      if (result.status === "200") {
        setTicket(result.data?.ticket || null);
        setOrders(result.data?.orders || []);
        setWinners(result.data?.winners || []);
      } else setMissing(true);
    }).catch(() => { if (mounted) setMissing(true); });
    return () => { mounted = false; };
  }, [token]);

  return (
    <Box sx={{ minHeight: "100dvh", background: "#f3f6f9", p: { xs: 1.5, md: 3 }, pb: "max(16px, env(safe-area-inset-bottom))" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Box component="img" src={cashiLogo} alt="Cashi" sx={{ height: 22, width: "auto" }} />
        <Typography sx={{ fontWeight: 750, color: consoleColors.ink }}>Lucky Draw Tickets</Typography>
      </Box>
      {missing && <Typography sx={{ fontSize: 18, fontWeight: 750 }}>This issued list link is not valid.</Typography>}
      {!missing && winnersOnly && (
        <>
          <Typography sx={{ fontSize: { xs: 18, md: 20 }, fontWeight: 800, mb: 0.4, wordBreak: "break-word" }}>{headingCase(ticket?.title) || "Winners"}</Typography>
          <Typography sx={{ color: consoleColors.muted, fontSize: 14, mb: 2 }}>{`${winners.length} winner${winners.length === 1 ? "" : "s"}`}</Typography>
          <TicketWinnerTable winners={winners} />
        </>
      )}
      {!missing && !winnersOnly && (
        <>
          <Typography sx={{ fontSize: { xs: 18, md: 20 }, fontWeight: 800, mb: 0.4, wordBreak: "break-word" }}>{headingCase(ticket?.title) || "Purchased Customers"}</Typography>
          <Typography sx={{ color: consoleColors.muted, fontSize: 14, mb: 2 }}>{issuedStatsLine(orders, ticket)}</Typography>
          <Box sx={{ mb: 1.5 }}>
            <TicketSearchField value={query} onChange={setQuery} />
          </Box>
          <IssuedCustomerTable ticket={ticket} orders={shown} emptyText={query.trim() ? "No matching name or mobile." : "No purchased customers yet."} />
        </>
      )}
    </Box>
  );
}
